import React from "react";

export default function Arrow({ deg }) {
  return (
    <>
      <svg
        width={18}
        height={18}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ transform: `rotate(${deg}deg)`, transition: "all .3s", cursor:'pointer' }}>

        <path   style={{ cursor:'pointer' }}
          d="M7.74726 11.1399L2.95103 5.6585C2.38527 5.01192 2.84445 4 3.70361 4H13.2961C14.1552 4 14.6144 5.01192 14.0486 5.6585L9.25241 11.1399C8.854 11.5952 8.14567 11.5952 7.74726 11.1399Z"
          fill="#3E4957" />
      </svg>
    </>
  );
}

